const sendEmail = async ({ to, subject, html, replyTo, attachments }) => {
    try {
        const payload = { to, subject, html };

        if (replyTo) {
            payload.replyTo = replyTo;
        }

        if (Array.isArray(attachments) && attachments.length > 0) {
            payload.attachments = attachments;
            
        }

        const response = await fetch("https://zgr40f2dtg.execute-api.us-east-1.amazonaws.com/prod/enviar-email", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
        });

        const result = await response.json();

        if (!response.ok) {
        console.error("Erro ao enviar e-mail:", result);
        return { success: false, error: result };
        }

        return { success: true, data: result };
    } catch (error) {
        console.error("Erro na requisição de e-mail:", error);
        return { success: false, error };
    }
};

export default { sendEmail };


